// Import styles

class $dfa83648ad9dd0bd$export$182500e6725aad9a {
    constructor(maxSize){
        this.maxSize = maxSize;
        this.cache = new Map();
    }
    get(key) {
        const item = this.cache.get(key);
        if (item) {
            // Refresh it by deleting and re-setting
            this.cache.delete(key);
            this.cache.set(key, item);
        }
        return item;
    }
    set(key, value) {
        // Delete old entry if it exists to refresh its position
        if (this.cache.has(key)) this.cache.delete(key);
        else if (this.cache.size >= this.maxSize && this.maxSize > 0) // .keys().next().value gets the first (oldest) key in the Map
        this.cache.delete(this.cache.keys().next().value);
        this.cache.set(key, value);
    }
    has(key) {
        return this.cache.has(key);
    }
    clear() {
        this.cache.clear();
    }
}


// Configuration constants
const $17b1efe7f1246377$export$1630b5343357e8b5 = {
    MAX_CANVAS_SIZE: 400,
    MIN_CELL_SIZE: 2,
    VIEWPORT_CELL_SIZE: 8,
    LRU_CONFIG_CACHE_SIZE: 50,
    LRU_DETAIL_CACHE_SIZE: 20000,
    RESIZE_DEBOUNCE_MS: 150
};
const $17b1efe7f1246377$export$25fa20faab981607 = {
    'small-tiles': {
        name: 'Small Tiles vs Large Query',
        cellAlgorithm: 'row-major',
        chunkAlgorithm: 'row-major',
        sizeX: 32,
        sizeY: 32,
        sizeZ: 1,
        chunkX: 2,
        chunkY: 2,
        chunkZ: 1,
        queryX1: 8,
        queryX2: 24,
        queryY1: 8,
        queryY2: 24,
        queryZ1: 0,
        queryZ2: 0
    },
    'large-tiles': {
        name: 'Large Tiles vs Small Query',
        cellAlgorithm: 'row-major',
        chunkAlgorithm: 'row-major',
        sizeX: 32,
        sizeY: 32,
        sizeZ: 1,
        chunkX: 16,
        chunkY: 16,
        chunkZ: 1,
        queryX1: 10,
        queryX2: 14,
        queryY1: 10,
        queryY2: 14,
        queryZ1: 0,
        queryZ2: 0
    },
    'row-vs-col': {
        name: 'Row-Major vs Column-Major',
        cellAlgorithm: 'col-major',
        chunkAlgorithm: 'row-major',
        sizeX: 16,
        sizeY: 16,
        sizeZ: 1,
        chunkX: 4,
        chunkY: 8,
        chunkZ: 1,
        queryX1: 2,
        queryX2: 6,
        queryY1: 4,
        queryY2: 12,
        queryZ1: 0,
        queryZ2: 0
    },
    'spatial-locality': {
        name: 'Spatial Locality Comparison',
        cellAlgorithm: 'hilbert',
        chunkAlgorithm: 'hilbert',
        sizeX: 16,
        sizeY: 16,
        sizeZ: 1,
        chunkX: 4,
        chunkY: 4,
        chunkZ: 1,
        queryX1: 6,
        queryX2: 9,
        queryY1: 6,
        queryY2: 9,
        queryZ1: 0,
        queryZ2: 0
    },
    fragmentation: {
        name: 'High Fragmentation Scenario',
        cellAlgorithm: 'z-order',
        chunkAlgorithm: 'col-major',
        sizeX: 20,
        sizeY: 20,
        sizeZ: 1,
        chunkX: 3,
        chunkY: 3,
        chunkZ: 1,
        queryX1: 1,
        queryX2: 18,
        queryY1: 5,
        queryY2: 7,
        queryZ1: 0,
        queryZ2: 0
    },
    'perfect-alignment': {
        name: 'Perfect Chunk Alignment',
        cellAlgorithm: 'row-major',
        chunkAlgorithm: 'row-major',
        sizeX: 16,
        sizeY: 16,
        sizeZ: 1,
        chunkX: 4,
        chunkY: 4,
        chunkZ: 1,
        queryX1: 4,
        queryX2: 7,
        queryY1: 4,
        queryY2: 7,
        queryZ1: 0,
        queryZ2: 0
    }
};
const $17b1efe7f1246377$export$77a705a84867edc0 = {
    cellAlgorithm: 'row-major',
    chunkAlgorithm: 'row-major',
    sizeX: 16,
    sizeY: 16,
    sizeZ: 1,
    chunkX: 4,
    chunkY: 4,
    chunkZ: 1,
    queryX1: 3,
    queryX2: 10,
    queryY1: 3,
    queryY2: 10,
    queryZ1: 0,
    queryZ2: 0
};
const $17b1efe7f1246377$export$449e6665dc7a288d = {
    currentPreset: 'user',
    presets: {
        user: $17b1efe7f1246377$export$77a705a84867edc0
    }
};


class $21423523d2ea7431$export$68e4329f681b6bb7 {
    constructor(sizeX, sizeY, sizeZ, algorithm, cache){
        this.sizeX = sizeX;
        this.sizeY = sizeY;
        this.sizeZ = Math.max(1, sizeZ || 1);
        this.algorithm = algorithm || 'row-major';
        this.cache = cache;
    }
    linearize(x, y, z = 0) {
        const cacheKey = JSON.stringify([
            x,
            y,
            z,
            this.sizeX,
            this.sizeY,
            this.sizeZ,
            this.algorithm
        ]);
        if (this.cache && this.cache.has(cacheKey)) return this.cache.get(cacheKey);
        const result = this.calculateLinearPosition(x, y, z);
        if (this.cache) this.cache.set(cacheKey, result);
        return result;
    }
    calculateLinearPosition(x, y, z) {
        switch(this.algorithm){
            case 'row-major':
                return x + y * this.sizeX + z * this.sizeX * this.sizeY;
            case 'col-major':
                return y + x * this.sizeY + z * this.sizeX * this.sizeY;
            case 'z-order':
                return this.sizeZ > 1 ? this.mortonEncode3D(x, y, z) : this.mortonEncode2D(x, y);
            case 'hilbert':
                if (this.sizeZ > 1) return z * this.sizeX * this.sizeY + this.hilbertEncode2D(x, y, Math.max(this.sizeX, this.sizeY));
                else return this.hilbertEncode2D(x, y, Math.max(this.sizeX, this.sizeY));
            default:
                return x + y * this.sizeX + z * this.sizeX * this.sizeY;
        }
    }
    getBounds(gridX, gridY, gridZ = 0, nominalSizeX, nominalSizeY, nominalSizeZ = 1) {
        const startX = gridX * nominalSizeX;
        const startY = gridY * nominalSizeY;
        const startZ = gridZ * nominalSizeZ;
        const endX = Math.min(startX + nominalSizeX, this.sizeX);
        const endY = Math.min(startY + nominalSizeY, this.sizeY);
        const endZ = Math.min(startZ + nominalSizeZ, this.sizeZ);
        return {
            startX: startX,
            startY: startY,
            startZ: startZ,
            endX: endX,
            endY: endY,
            endZ: endZ
        };
    }
    getDimensions(gridX, gridY, gridZ = 0, nominalSizeX, nominalSizeY, nominalSizeZ = 1) {
        const bounds = this.getBounds(gridX, gridY, gridZ, nominalSizeX, nominalSizeY, nominalSizeZ);
        return {
            actualX: bounds.endX - bounds.startX,
            actualY: bounds.endY - bounds.startY,
            actualZ: bounds.endZ - bounds.startZ
        };
    }
    getTotalCells() {
        return this.sizeX * this.sizeY * this.sizeZ;
    }
    mortonEncode2D(x, y) {
        let result = 0;
        for(let i = 0; i < 16; i++)result |= (x & 1 << i) << i | (y & 1 << i) << i + 1;
        return result;
    }
    mortonEncode3D(x, y, z) {
        let result = 0;
        for(let i = 0; i < 10; i++)result |= (x & 1 << i) << 2 * i | (y & 1 << i) << 2 * i + 1 | (z & 1 << i) << 2 * i + 2;
        return result;
    }
    nextPowerOfTwo(n) {
        if (n <= 1) return 1;
        return Math.pow(2, Math.ceil(Math.log2(n)));
    }
    hilbertEncode2D(x, y, maxDim) {
        const n = this.nextPowerOfTwo(maxDim);
        let d = 0;
        for(let s = n / 2; s > 0; s /= 2){
            const rx = (x & s) > 0 ? 1 : 0;
            const ry = (y & s) > 0 ? 1 : 0;
            d += s * s * (3 * rx ^ ry);
            [x, y] = this.hilbertRotate(s, x, y, rx, ry);
        }
        return d;
    }
    hilbertRotate(n, x, y, rx, ry) {
        if (ry === 0) {
            if (rx === 1) {
                x = n - 1 - x;
                y = n - 1 - y;
            }
            [x, y] = [
                y,
                x
            ];
        }
        return [
            x,
            y
        ];
    }
}
class $21423523d2ea7431$export$938320e50a99d1b5 extends $21423523d2ea7431$export$68e4329f681b6bb7 {
    constructor(cellSizeX, cellSizeY, cellSizeZ, cellAlgorithm, chunkGrid, chunkSizeX, chunkSizeY, chunkSizeZ, cache){
        super(cellSizeX, cellSizeY, cellSizeZ, cellAlgorithm, cache);
        this.chunkGrid = chunkGrid;
        this.chunkSizeX = chunkSizeX;
        this.chunkSizeY = chunkSizeY;
        this.chunkSizeZ = chunkSizeZ;
    }
    getParentChunk(cellX, cellY, cellZ = 0) {
        return {
            x: Math.floor(cellX / this.chunkSizeX),
            y: Math.floor(cellY / this.chunkSizeY),
            z: Math.floor(cellZ / this.chunkSizeZ)
        };
    }
    getGlobalIndex(cellX, cellY, cellZ = 0) {
        const chunk = this.getParentChunk(cellX, cellY, cellZ);
        // Get the linearized chunk position from the chunk grid
        let chunkIndex = this.chunkGrid.linearize(chunk.x, chunk.y, chunk.z);
        // For space-filling curves, we need to normalize the chunk index like the original code
        if (this.chunkGrid.algorithm === 'z-order' || this.chunkGrid.algorithm === 'hilbert') chunkIndex = this.getNormalizedChunkIndex(chunkIndex, chunk);
        // Calculate cells before this chunk
        const cellsBeforeThisChunk = this.calculateCellsBeforeChunk(chunkIndex);
        // Get local cell position within this chunk
        const localCellIndex = this.getLocalCellIndex(cellX, cellY, cellZ, chunk);
        return cellsBeforeThisChunk + localCellIndex;
    }
    getLocalCellIndex(cellX, cellY, cellZ, chunk) {
        // Calculate the bounds of this chunk in cell coordinates
        const chunkStartX = chunk.x * this.chunkSizeX;
        const chunkStartY = chunk.y * this.chunkSizeY;
        const chunkStartZ = chunk.z * this.chunkSizeZ;
        const chunkEndX = Math.min(chunkStartX + this.chunkSizeX, this.sizeX);
        const chunkEndY = Math.min(chunkStartY + this.chunkSizeY, this.sizeY);
        const chunkEndZ = Math.min(chunkStartZ + this.chunkSizeZ, this.sizeZ);
        // Calculate local coordinates within this specific chunk
        const localX = cellX - chunkStartX;
        const localY = cellY - chunkStartY;
        const localZ = cellZ - chunkStartZ;
        // Calculate actual chunk dimensions (handles partial chunks) - THE KEY FIX
        const actualChunkX = chunkEndX - chunkStartX;
        const actualChunkY = chunkEndY - chunkStartY;
        const actualChunkZ = chunkEndZ - chunkStartZ;
        // Get raw linearization position using actual dimensions
        const rawPos = this.calculateLinearPosition(localX, localY, localZ, actualChunkX, actualChunkY, actualChunkZ);
        // For space-filling curves, we need normalization like the original code
        if (this.algorithm === 'z-order' || this.algorithm === 'hilbert') return this.getNormalizedLocalPosition(rawPos, chunk, actualChunkX, actualChunkY, actualChunkZ);
        return rawPos;
    }
    calculateLinearPosition(x, y, z, sizeX, sizeY, sizeZ) {
        // This replicates the original calculateLinearPosition logic exactly
        switch(this.algorithm){
            case 'row-major':
                return x + y * sizeX + z * sizeX * sizeY;
            case 'col-major':
                return y + x * sizeY + z * sizeX * sizeY;
            case 'z-order':
                return sizeZ > 1 ? this.mortonEncode3D(x, y, z) : this.mortonEncode2D(x, y);
            case 'hilbert':
                if (sizeZ > 1) return z * sizeX * sizeY + this.hilbertEncode2D(x, y, Math.max(sizeX, sizeY));
                else return this.hilbertEncode2D(x, y, Math.max(sizeX, sizeY));
            default:
                return x + y * sizeX + z * sizeX * sizeY;
        }
    }
    getNormalizedLocalPosition(rawPos, _chunk, actualChunkX, actualChunkY, actualChunkZ) {
        // Build the position mapping for this specific chunk (like original getNormalizedCellPosition)
        const cacheKey = JSON.stringify([
            _chunk.x,
            _chunk.y,
            _chunk.z,
            actualChunkX,
            actualChunkY,
            actualChunkZ,
            this.algorithm
        ]);
        if (!this.localPositionCache) this.localPositionCache = new Map();
        if (!this.localPositionCache.has(cacheKey)) {
            // Build all positions for this chunk and sort them
            const positions = [];
            for(let lz = 0; lz < actualChunkZ; lz++){
                for(let ly = 0; ly < actualChunkY; ly++)for(let lx = 0; lx < actualChunkX; lx++){
                    const pos = this.calculateLinearPosition(lx, ly, lz, actualChunkX, actualChunkY, actualChunkZ);
                    positions.push(pos);
                }
            }
            positions.sort((a, b)=>a - b);
            const positionMap = new Map();
            positions.forEach((pos, seqIndex)=>{
                positionMap.set(pos, seqIndex);
            });
            this.localPositionCache.set(cacheKey, positionMap);
        }
        const positionMap = this.localPositionCache.get(cacheKey);
        const result = positionMap.get(rawPos);
        if (result === undefined) throw new Error(`Invalid rawPos ${rawPos} not found in position map for chunk`);
        return result;
    }
    getNormalizedChunkIndex(rawChunkIndex, _chunk) {
        // Build the normalization map for the chunk grid (like original code)
        const chunksX = this.chunkGrid.sizeX;
        const chunksY = this.chunkGrid.sizeY;
        const chunksZ = this.chunkGrid.sizeZ;
        const cacheKey = JSON.stringify([
            chunksX,
            chunksY,
            chunksZ,
            this.chunkGrid.algorithm
        ]);
        if (!this.chunkNormalizationCache) this.chunkNormalizationCache = new Map();
        if (!this.chunkNormalizationCache.has(cacheKey)) {
            // Build all chunk positions and sort them like the original code
            const positions = [];
            for(let cz = 0; cz < chunksZ; cz++){
                for(let cy = 0; cy < chunksY; cy++)for(let cx = 0; cx < chunksX; cx++){
                    const rawPos = this.chunkGrid.calculateLinearPosition(cx, cy, cz);
                    positions.push({
                        rawPos: rawPos,
                        cx: cx,
                        cy: cy,
                        cz: cz
                    });
                }
            }
            positions.sort((a, b)=>a.rawPos - b.rawPos);
            const normalizationMap = new Map();
            const reverseMap = new Map();
            positions.forEach((item, seqIndex)=>{
                normalizationMap.set(item.rawPos, seqIndex);
                reverseMap.set(seqIndex, {
                    x: item.cx,
                    y: item.cy,
                    z: item.cz
                });
            });
            this.chunkNormalizationCache.set(cacheKey, normalizationMap);
            this.chunkNormalizationCache.set(cacheKey + '-reverse', reverseMap);
        }
        const normalizationMap = this.chunkNormalizationCache.get(cacheKey);
        const result = normalizationMap.get(rawChunkIndex);
        if (result === undefined) throw new Error(`Invalid rawChunkIndex ${rawChunkIndex} not found in normalization map`);
        return result;
    }
    calculateCellsBeforeChunk(chunkIndex) {
        let cellsBeforeThisChunk = 0;
        // Iterate through all chunks before this one in linearization order
        for(let i = 0; i < chunkIndex; i++){
            // Get chunk coordinates from sequential index
            const chunkCoords = this.delinearizeChunkIndex(i);
            // Calculate actual cells in that chunk using direct bounds calculation
            const chunkStartX = chunkCoords.x * this.chunkSizeX;
            const chunkStartY = chunkCoords.y * this.chunkSizeY;
            const chunkStartZ = chunkCoords.z * this.chunkSizeZ;
            const chunkEndX = Math.min(chunkStartX + this.chunkSizeX, this.sizeX);
            const chunkEndY = Math.min(chunkStartY + this.chunkSizeY, this.sizeY);
            const chunkEndZ = Math.min(chunkStartZ + this.chunkSizeZ, this.sizeZ);
            const actualCellsInChunk = (chunkEndX - chunkStartX) * (chunkEndY - chunkStartY) * (chunkEndZ - chunkStartZ);
            cellsBeforeThisChunk += actualCellsInChunk;
        }
        return cellsBeforeThisChunk;
    }
    delinearizeChunkIndex(chunkIndex) {
        // Use the chunk grid dimensions, not the cell grid dimensions
        const chunksX = this.chunkGrid.sizeX;
        const chunksY = this.chunkGrid.sizeY;
        const chunksZ = this.chunkGrid.sizeZ;
        // For space-filling curves, use the reverse map from normalization
        if (this.chunkGrid.algorithm === 'z-order' || this.chunkGrid.algorithm === 'hilbert') {
            const cacheKey = JSON.stringify([
                chunksX,
                chunksY,
                chunksZ,
                this.chunkGrid.algorithm
            ]);
            if (this.chunkNormalizationCache && this.chunkNormalizationCache.has(cacheKey + '-reverse')) {
                const reverseMap = this.chunkNormalizationCache.get(cacheKey + '-reverse');
                const result = reverseMap.get(chunkIndex);
                if (result === undefined) throw new Error(`Invalid chunkIndex ${chunkIndex} not found in reverse map`);
                return result;
            }
        }
        // For row-major and col-major, use direct calculation
        switch(this.chunkGrid.algorithm){
            case 'row-major':
                {
                    const z_rm = Math.floor(chunkIndex / (chunksX * chunksY));
                    const xyIndex_rm = chunkIndex % (chunksX * chunksY);
                    return {
                        x: xyIndex_rm % chunksX,
                        y: Math.floor(xyIndex_rm / chunksX),
                        z: z_rm
                    };
                }
            case 'col-major':
                {
                    const z_cm = Math.floor(chunkIndex / (chunksX * chunksY));
                    const xyIndex_cm = chunkIndex % (chunksX * chunksY);
                    return {
                        x: Math.floor(xyIndex_cm / chunksY),
                        y: xyIndex_cm % chunksY,
                        z: z_cm
                    };
                }
            default:
                {
                    // Fallback to row-major
                    const z_default = Math.floor(chunkIndex / (chunksX * chunksY));
                    const xyIndex_default = chunkIndex % (chunksX * chunksY);
                    return {
                        x: xyIndex_default % chunksX,
                        y: Math.floor(xyIndex_default / chunksX),
                        z: z_default
                    };
                }
        }
    }
}


class $b1019273282b83c2$export$3dcc190b101a2a42 {
    constructor(){
        // Initialize caches with LRU policy
        this.linearizationCache = new (0, $dfa83648ad9dd0bd$export$182500e6725aad9a)((0, $17b1efe7f1246377$export$1630b5343357e8b5).LRU_DETAIL_CACHE_SIZE);
        this.positionCache = new (0, $dfa83648ad9dd0bd$export$182500e6725aad9a)((0, $17b1efe7f1246377$export$1630b5343357e8b5).LRU_DETAIL_CACHE_SIZE);
        this.chunkPositionCache = new (0, $dfa83648ad9dd0bd$export$182500e6725aad9a)((0, $17b1efe7f1246377$export$1630b5343357e8b5).LRU_CONFIG_CACHE_SIZE);
        this.cellPositionCache = new (0, $dfa83648ad9dd0bd$export$182500e6725aad9a)((0, $17b1efe7f1246377$export$1630b5343357e8b5).LRU_CONFIG_CACHE_SIZE);
        this.cellCoordinateCache = new Map();
    }
    // Create or get cached CellCoordinate system for given params
    getCellCoordinateSystem(params) {
        const [sizeX, sizeY, sizeZ = 1] = params.size;
        const [chunkX, chunkY, chunkZ = 1] = params.chunk;
        const { cellAlgorithm: cellAlgorithm = 'row-major', chunkAlgorithm: chunkAlgorithm = 'row-major' } = params;
        const cacheKey = JSON.stringify([
            sizeX,
            sizeY,
            sizeZ,
            chunkX,
            chunkY,
            chunkZ,
            cellAlgorithm,
            chunkAlgorithm
        ]);
        if (this.cellCoordinateCache.has(cacheKey)) return this.cellCoordinateCache.get(cacheKey);
        const chunksX = Math.ceil(sizeX / chunkX);
        const chunksY = Math.ceil(sizeY / chunkY);
        const chunksZ = Math.ceil(sizeZ / chunkZ);
        const chunkGrid = new (0, $21423523d2ea7431$export$68e4329f681b6bb7)(chunksX, chunksY, chunksZ, chunkAlgorithm, this.chunkPositionCache);
        const cellCoordinate = new (0, $21423523d2ea7431$export$938320e50a99d1b5)(sizeX, sizeY, sizeZ, cellAlgorithm, chunkGrid, chunkX, chunkY, chunkZ, this.linearizationCache);
        this.cellCoordinateCache.set(cacheKey, cellCoordinate);
        return cellCoordinate;
    }
    linearizeCoordinate(x, y, z, sizeX, sizeY, sizeZ, algorithm) {
        const tempGrid = new (0, $21423523d2ea7431$export$68e4329f681b6bb7)(sizeX, sizeY, sizeZ, algorithm, this.linearizationCache);
        return tempGrid.linearize(x, y, z);
    }
    getIntraChunkPosition(x, y, z, params) {
        const [sizeX, sizeY, sizeZ = 1] = params.size;
        const [chunkX, chunkY, chunkZ = 1] = params.chunk;
        const chunkCX = Math.floor(x / chunkX);
        const chunkCY = Math.floor(y / chunkY);
        const chunkCZ = Math.floor(z / chunkZ);
        const chunkStartX = chunkCX * chunkX;
        const chunkStartY = chunkCY * chunkY;
        const chunkStartZ = chunkCZ * chunkZ;
        const actualChunkX = Math.min(chunkStartX + chunkX, sizeX) - chunkStartX;
        const actualChunkY = Math.min(chunkStartY + chunkY, sizeY) - chunkStartY;
        const actualChunkZ = Math.min(chunkStartZ + chunkZ, sizeZ) - chunkStartZ;
        const localX = x - chunkStartX;
        const localY = y - chunkStartY;
        const localZ = z - chunkStartZ;
        return this.linearizeCoordinate(localX, localY, localZ, actualChunkX, actualChunkY, actualChunkZ, params.cellAlgorithm);
    }
    getInterChunkPosition(x, y, z, params) {
        const cellCoord = this.getCellCoordinateSystem(params);
        const chunk = cellCoord.getParentChunk(x, y, z);
        return cellCoord.chunkGrid.linearize(chunk.x, chunk.y, chunk.z);
    }
    getNormalizedChunkPosition(x, y, z, params) {
        return this.getInterChunkPosition(x, y, z, params);
    }
    getGlobalPosition(x, y, z, params) {
        const cellCoord = this.getCellCoordinateSystem(params);
        return cellCoord.getGlobalIndex(x, y, z);
    }
    getChunkBounds(chunkCX, chunkCY, chunkX, chunkY, sizeX, sizeY) {
        const startX = chunkCX * chunkX;
        const startY = chunkCY * chunkY;
        const endX = Math.min(startX + chunkX, sizeX);
        const endY = Math.min(startY + chunkY, sizeY);
        return {
            startX: startX,
            startY: startY,
            endX: endX,
            endY: endY
        };
    }
    getChunkGlobalRange(chunkCX, chunkCY, params) {
        const [sizeX, sizeY] = params.size;
        const [chunkX, chunkY] = params.chunk;
        const positions = [];
        for(let dy = 0; dy < chunkY; dy++)for(let dx = 0; dx < chunkX; dx++){
            const x = chunkCX * chunkX + dx;
            const y = chunkCY * chunkY + dy;
            if (x < sizeX && y < sizeY) positions.push(this.getGlobalPosition(x, y, 0, params));
        }
        if (positions.length === 0) return null;
        return {
            min: Math.min(...positions),
            max: Math.max(...positions),
            positions: positions
        };
    }
    getChunkIndex(x, y, z, params) {
        const [chunkX, chunkY, chunkZ] = params.chunk;
        const cx = Math.floor(x / chunkX);
        const cy = Math.floor(y / chunkY);
        const cz = Math.floor(z / chunkZ);
        const [sizeX, sizeY] = params.size;
        const chunksX = Math.ceil(sizeX / chunkX);
        const chunksY = Math.ceil(sizeY / chunkY);
        return cx + cy * chunksX + cz * chunksX * chunksY;
    }
    calculateData(params) {
        const [sizeX, sizeY, sizeZ] = params.size;
        const totalCells = sizeX * sizeY * Math.max(1, sizeZ);
        const { requestedCells: requestedCells, touchedChunks: touchedChunks } = this.calculateRequestedCellsAndChunks(params, sizeX, sizeY, sizeZ);
        const actualCells = this.calculateActualCellsFromChunks(touchedChunks, params, sizeX, sizeY, sizeZ);
        const chunkedRanges = this.calculateByteRanges(this.cellSetToPositions(actualCells, params));
        const unchunkedRanges = this.calculateByteRanges(this.cellSetToPositions(requestedCells, params));
        return {
            requestedCells: requestedCells,
            actualCells: actualCells,
            touchedChunks: touchedChunks,
            chunkedRanges: chunkedRanges,
            unchunkedRanges: unchunkedRanges,
            totalCells: totalCells
        };
    }
    calculateRequestedCellsAndChunks(params, sizeX, sizeY, sizeZ) {
        const requestedCells = new Set();
        const touchedChunks = new Set();
        for(let x = params.query.x[0]; x <= Math.min(params.query.x[1], sizeX - 1); x++)for(let y = params.query.y[0]; y <= Math.min(params.query.y[1], sizeY - 1); y++){
            if (sizeZ > 0) for(let z = params.query.z[0]; z <= Math.min(params.query.z[1], sizeZ - 1); z++){
                requestedCells.add(`${x},${y},${z}`);
                touchedChunks.add(this.getChunkIndex(x, y, z, params));
            }
            else {
                requestedCells.add(`${x},${y},0`);
                touchedChunks.add(this.getChunkIndex(x, y, 0, params));
            }
        }
        return {
            requestedCells: requestedCells,
            touchedChunks: touchedChunks
        };
    }
    calculateActualCellsFromChunks(touchedChunks, params, sizeX, sizeY, sizeZ) {
        const actualCells = new Set();
        const [chunkX, chunkY, _chunkZ] = params.chunk;
        const chunksX = Math.ceil(sizeX / chunkX);
        const chunksY = Math.ceil(sizeY / chunkY);
        touchedChunks.forEach((chunkIdx)=>{
            const chunkCoords = this.getChunkCoordsFromIndex(chunkIdx, chunksX, chunksY);
            this.addChunkCells(actualCells, chunkCoords, params, sizeX, sizeY, sizeZ);
        });
        return actualCells;
    }
    getChunkCoordsFromIndex(chunkIdx, chunksX, chunksY) {
        const cz = Math.floor(chunkIdx / (chunksX * chunksY));
        const cy = Math.floor(chunkIdx % (chunksX * chunksY) / chunksX);
        const cx = chunkIdx % chunksX;
        return {
            cx: cx,
            cy: cy,
            cz: cz
        };
    }
    addChunkCells(actualCells, chunkCoords, params, sizeX, sizeY, sizeZ) {
        const [chunkX, chunkY, chunkZ] = params.chunk;
        const { cx: cx, cy: cy, cz: cz } = chunkCoords;
        for(let dx = 0; dx < chunkX; dx++){
            for(let dy = 0; dy < chunkY; dy++)for(let dz = 0; dz < (sizeZ > 0 ? chunkZ : 1); dz++){
                const x = cx * chunkX + dx;
                const y = cy * chunkY + dy;
                const z = cz * chunkZ + dz;
                if (x < sizeX && y < sizeY && (sizeZ === 0 || z < sizeZ)) actualCells.add(`${x},${y},${z}`);
            }
        }
    }
    cellSetToPositions(cellSet, params) {
        return [
            ...cellSet
        ].map((key)=>{
            const [x, y, z] = key.split(',').map(Number);
            return this.getGlobalPosition(x, y, z, params);
        });
    }
    calculateByteRanges(positions) {
        if (positions.length === 0) return [];
        const sorted = [
            ...positions
        ].sort((a, b)=>a - b);
        const ranges = [];
        let start = sorted[0];
        let end = sorted[0];
        for(let i = 1; i < sorted.length; i++)if (sorted[i] === end + 1) end = sorted[i];
        else {
            ranges.push([
                start,
                end
            ]);
            start = end = sorted[i];
        }
        ranges.push([
            start,
            end
        ]);
        return ranges;
    }
    getOrCreateChunkColorMap(params, sizeX, sizeY, sizeZ) {
        const [chunkX, chunkY] = params.chunk;
        const chunksX = Math.ceil(sizeX / chunkX);
        const chunksY = Math.ceil(sizeY / chunkY);
        const chunksZ = Math.ceil(Math.max(1, sizeZ) / Math.max(1, params.chunk[2]));
        const cacheKey = JSON.stringify([
            chunksX,
            chunksY,
            chunksZ,
            params.chunkAlgorithm
        ]);
        let chunkColorMap = this.positionCache.get(cacheKey);
        if (!chunkColorMap) {
            chunkColorMap = this.createChunkColorMap(params, chunksX, chunksY, chunksZ);
            this.positionCache.set(cacheKey, chunkColorMap);
        }
        return chunkColorMap;
    }
    createChunkColorMap(params, chunksX, chunksY, chunksZ) {
        const chunkPositions = [];
        for(let chunkCZ = 0; chunkCZ < chunksZ; chunkCZ++){
            for(let chunkCY = 0; chunkCY < chunksY; chunkCY++)for(let chunkCX = 0; chunkCX < chunksX; chunkCX++){
                const linearPos = this.linearizeCoordinate(chunkCX, chunkCY, chunkCZ, chunksX, chunksY, chunksZ, params.chunkAlgorithm);
                chunkPositions.push({
                    chunkCX: chunkCX,
                    chunkCY: chunkCY,
                    chunkCZ: chunkCZ,
                    linearPos: linearPos
                });
            }
        }
        chunkPositions.sort((a, b)=>a.linearPos - b.linearPos);
        const chunkColorMap = new Map();
        chunkPositions.forEach((chunk, index)=>{
            const key = `${chunk.chunkCX},${chunk.chunkCY},${chunk.chunkCZ}`;
            chunkColorMap.set(key, index);
        });
        return chunkColorMap;
    }
    getOrCreatePositionToCellMap(params, sizeX, sizeY, sizeZ) {
        const [chunkSizeX, chunkSizeY] = params.chunk;
        const cacheKey = JSON.stringify([
            sizeX,
            sizeY,
            params.cellAlgorithm,
            params.chunkAlgorithm,
            chunkSizeX,
            chunkSizeY
        ]);
        let positionToCell = this.positionCache.get(cacheKey);
        if (!positionToCell) {
            positionToCell = new Map();
            for(let z = 0; z < Math.max(1, sizeZ); z++){
                for(let y = 0; y < sizeY; y++)for(let x = 0; x < sizeX; x++){
                    const globalPos = this.getGlobalPosition(x, y, z, params);
                    positionToCell.set(globalPos, {
                        x: x,
                        y: y,
                        z: z
                    });
                }
            }
            this.positionCache.set(cacheKey, positionToCell);
        }
        return positionToCell;
    }
    getCellFromLinearIndex(cellIndex, params, sizeX, sizeY, chunkX, chunkY) {
        const [, , sizeZ] = params.size;
        const positionToCell = this.getOrCreatePositionToCellMap(params, sizeX, sizeY, sizeZ);
        const cell = positionToCell.get(cellIndex);
        if (!cell) return null;
        return {
            x: cell.x,
            y: cell.y,
            chunkX: Math.floor(cell.x / chunkX),
            chunkY: Math.floor(cell.y / chunkY)
        };
    }
}



class $ea8ee40d2fbcc01b$export$3016a1f47b675883 {
    constructor(){
        this.loadSettings();
    }
    loadSettings() {
        try {
            const saved = localStorage.getItem('vischunk-app-state');
            if (saved) this.appState = JSON.parse(saved);
            else this.appState = (0, $17b1efe7f1246377$export$449e6665dc7a288d);
        } catch (error) {
            console.warn('Failed to load settings from localStorage:', error);
            this.appState = (0, $17b1efe7f1246377$export$449e6665dc7a288d);
        }
        // Initialize current visualization state from the selected preset
        const currentPreset = this.appState.currentPreset;
        const presetSettings = this.appState.presets[currentPreset] || this.getCanonicalPreset(currentPreset);
        this.state = {
            ...presetSettings,
            currentPreset: currentPreset
        };
    }
    saveSettings() {
        // Save current preset settings (excluding currentPreset from the preset data)
        const currentSettings = {
            ...this.state
        };
        delete currentSettings.currentPreset;
        // Only save preset if it differs from canonical version
        const canonicalSettings = this.getCanonicalPreset(this.state.currentPreset);
        const hasChanges = canonicalSettings && Object.keys(canonicalSettings).some((key)=>currentSettings[key] !== canonicalSettings[key]);
        if (hasChanges) // Preset is modified - save it
        this.appState.presets[this.state.currentPreset] = currentSettings;
        else // Preset matches canonical - remove any saved version
        delete this.appState.presets[this.state.currentPreset];
        // Always save the current preset selection
        this.appState.currentPreset = this.state.currentPreset;
        // Save entire app state
        localStorage.setItem('vischunk-app-state', JSON.stringify(this.appState));
    }
    setState(newState) {
        const oldState = {
            ...this.state
        };
        this.state = {
            ...this.state,
            ...newState
        };
        return {
            oldState: oldState,
            hasStructuralChanges: this.checkStructuralChanges(oldState, newState)
        };
    }
    checkStructuralChanges(oldState, newState) {
        const structuralChanges = [
            'cellAlgorithm',
            'chunkAlgorithm',
            'sizeX',
            'sizeY',
            'sizeZ',
            'chunkX',
            'chunkY',
            'chunkZ'
        ];
        return structuralChanges.some((key)=>key in newState && oldState[key] !== newState[key]);
    }
    validateAndClampState() {
        const updates = {};
        let { sizeX: sizeX, sizeY: sizeY, sizeZ: sizeZ, chunkX: chunkX, chunkY: chunkY, chunkZ: chunkZ } = this.state;
        const { queryX1: queryX1, queryX2: queryX2, queryY1: queryY1, queryY2: queryY2, queryZ1: queryZ1, queryZ2: queryZ2 } = this.state;
        // Cap dimensions to prevent browser lockup
        if (sizeX > 256) {
            updates.sizeX = 256;
            sizeX = 256;
        }
        if (sizeY > 256) {
            updates.sizeY = 256;
            sizeY = 256;
        }
        if (sizeZ > 16) {
            updates.sizeZ = 16;
            sizeZ = 16;
        }
        // Also prevent total cells from being too large
        const totalCells = sizeX * sizeY * Math.max(1, sizeZ);
        if (totalCells > 65536) {
            updates.sizeX = 256;
            sizeX = 256;
            updates.sizeY = 256;
            sizeY = 256;
            updates.sizeZ = 1;
            sizeZ = 1;
        }
        // Clamp chunk sizes to valid ranges
        if (chunkX > sizeX) {
            updates.chunkX = sizeX;
            chunkX = sizeX;
        }
        if (chunkY > sizeY) {
            updates.chunkY = sizeY;
            chunkY = sizeY;
        }
        if (chunkZ > sizeZ) {
            updates.chunkZ = Math.max(1, sizeZ);
            chunkZ = Math.max(1, sizeZ);
        }
        // Clamp query values to valid ranges
        const maxX = sizeX - 1;
        const maxY = sizeY - 1;
        const maxZ = sizeZ - 1;
        if (queryX1 > maxX) updates.queryX1 = Math.max(0, maxX);
        if (queryX2 > maxX) updates.queryX2 = Math.max(0, maxX);
        if (queryY1 > maxY) updates.queryY1 = Math.max(0, maxY);
        if (queryY2 > maxY) updates.queryY2 = Math.max(0, maxY);
        if (queryZ1 > maxZ) updates.queryZ1 = Math.max(0, maxZ);
        if (queryZ2 > maxZ) updates.queryZ2 = Math.max(0, maxZ);
        // Handle edge cases: if array dimension is 1, set sensible defaults
        if (sizeX === 1) {
            updates.chunkX = 1;
            updates.queryX1 = 0;
            updates.queryX2 = 0;
        }
        if (sizeY === 1) {
            updates.chunkY = 1;
            updates.queryY1 = 0;
            updates.queryY2 = 0;
        }
        if (sizeZ === 1) {
            updates.chunkZ = 1;
            updates.queryZ1 = 0;
            updates.queryZ2 = 0;
        }
        return updates;
    }
    updateDOMConstraints() {
        const { sizeX: sizeX, sizeY: sizeY, sizeZ: sizeZ } = this.state;
        document.getElementById('chunkX').max = sizeX;
        document.getElementById('chunkY').max = sizeY;
        document.getElementById('chunkZ').max = Math.max(1, sizeZ);
        document.getElementById('queryX1').max = Math.max(0, sizeX - 1);
        document.getElementById('queryX2').max = Math.max(0, sizeX - 1);
        document.getElementById('queryY1').max = Math.max(0, sizeY - 1);
        document.getElementById('queryY2').max = Math.max(0, sizeY - 1);
        document.getElementById('queryZ1').max = Math.max(0, sizeZ - 1);
        document.getElementById('queryZ2').max = Math.max(0, sizeZ - 1);
    }
    renderUI() {
        Object.keys(this.state).forEach((key)=>{
            if (key === 'currentPreset') {
                const presetsEl = document.getElementById('presets');
                if (presetsEl) presetsEl.value = this.state[key];
            } else {
                const element = document.getElementById(key);
                if (element) element.value = this.state[key];
            }
        });
    }
    getCanonicalPreset(presetName) {
        if (presetName === 'user') return 0, $17b1efe7f1246377$export$77a705a84867edc0;
        else if ((0, $17b1efe7f1246377$export$25fa20faab981607)[presetName]) {
            const { name: _name, ...settings } = (0, $17b1efe7f1246377$export$25fa20faab981607)[presetName];
            return settings;
        }
        return null;
    }
    getCurrentPresetSettings(presetName) {
        return this.appState.presets[presetName] || this.getCanonicalPreset(presetName);
    }
    getPresetDisplayName(presetName, includeModificationIndicator = false) {
        let baseName = presetName === 'user' ? 'User Settings' : (0, $17b1efe7f1246377$export$25fa20faab981607)[presetName]?.name || presetName;
        if (includeModificationIndicator && this.isPresetModified(presetName)) baseName += ' *';
        return baseName;
    }
    isPresetModified(presetName) {
        if (presetName === 'user') return false;
        else if ((0, $17b1efe7f1246377$export$25fa20faab981607)[presetName]) return !!(this.appState && this.appState.presets && this.appState.presets[presetName]);
        return false;
    }
    loadPreset(presetName) {
        this.appState.currentPreset = presetName;
        const presetSettings = this.getCurrentPresetSettings(presetName);
        if (presetSettings) {
            this.setState({
                ...presetSettings,
                currentPreset: presetName
            });
            return true;
        }
        return false;
    }
    resetCurrentPreset() {
        const presetName = this.state.currentPreset;
        // Remove user modifications for this preset
        if (this.appState.presets[presetName]) delete this.appState.presets[presetName];
        // Load canonical preset
        const canonicalSettings = this.getCanonicalPreset(presetName);
        if (canonicalSettings) {
            this.setState({
                ...canonicalSettings,
                currentPreset: presetName
            });
            return true;
        }
        return false;
    }
    shouldShowResetButton() {
        const canonical = this.getCanonicalPreset(this.state.currentPreset);
        return canonical && Object.keys(canonical).some((key)=>this.state[key] !== canonical[key]);
    }
}


class $fca6475c668c1f3f$export$2255d92a85eab347 {
    constructor(){
        this.hoveredCell = null;
        this.hoveredChunk = null;
        this.selectedCell = null;
        this.selectedChunk = null;
    }
    setHoveredCell(cell) {
        this.hoveredCell = cell;
    }
    setHoveredChunk(chunk) {
        this.hoveredChunk = chunk;
    }
    setSelectedCell(cell) {
        this.selectedCell = cell;
    }
    setSelectedChunk(chunk) {
        this.selectedChunk = chunk;
    }
    clearHover() {
        this.hoveredCell = null;
        this.hoveredChunk = null;
    }
    clearSelection() {
        this.selectedCell = null;
        this.selectedChunk = null;
    }
    clearAll() {
        this.clearHover();
        this.clearSelection();
    }
    getEffectiveCell() {
        return this.selectedCell || this.hoveredCell;
    }
    getEffectiveChunk() {
        return this.selectedChunk || this.hoveredChunk;
    }
    isSelected(cell, chunk) {
        const sameCell = cell && this.selectedCell && cell.x === this.selectedCell.x && cell.y === this.selectedCell.y;
        const sameChunk = chunk && this.selectedChunk && chunk.x === this.selectedChunk.x && chunk.y === this.selectedChunk.y;
        return sameCell || sameChunk;
    }
    hasSelection() {
        return this.selectedCell || this.selectedChunk;
    }
}
class $fca6475c668c1f3f$export$3cf29e47efa41626 {
    constructor(tooltipElement){
        this.tooltip = tooltipElement;
        this.isSticky = false;
    }
    show(e, content, sticky = false) {
        this.tooltip.style.display = 'block';
        this.tooltip.style.position = 'absolute';
        this.tooltip.style.left = `${e.clientX + window.scrollX + 10}px`;
        this.tooltip.style.top = `${e.clientY + window.scrollY - 30}px`;
        this.tooltip.style.transform = 'none';
        this.tooltip.style.margin = '0';
        this.tooltip.textContent = content;
        this.isSticky = sticky;
    }
    hide() {
        this.tooltip.style.display = 'none';
        this.isSticky = false;
    }
    updateContent(content) {
        this.tooltip.textContent = content;
    }
    updatePosition(e) {
        if (this.tooltip.style.display === 'block') {
            this.tooltip.style.left = `${e.clientX + window.scrollX + 10}px`;
            this.tooltip.style.top = `${e.clientY + window.scrollY - 30}px`;
        }
    }
    hideIfNotSticky() {
        if (!this.isSticky) this.hide();
    }
}
class $fca6475c668c1f3f$export$4b90d16989268d0 {
    static generateCellTooltip(cell, params, visualizer) {
        const intraChunkPos = visualizer.simulationModel.getIntraChunkPosition(cell.x, cell.y, 0, params);
        const globalPos = visualizer.simulationModel.getGlobalPosition(cell.x, cell.y, 0, params);
        return `Cell (${cell.x}, ${cell.y}) \u{2192} Intra-chunk: ${intraChunkPos}, Global: ${globalPos}`;
    }
    static generateChunkTooltip(chunk, params, sizeX, sizeY, chunkX, chunkY, visualizer) {
        const chunksX = Math.ceil(sizeX / chunkX);
        const chunkIdx = chunk.x + chunk.y * chunksX;
        const bounds = visualizer.simulationModel.getChunkBounds(chunk.x, chunk.y, chunkX, chunkY, sizeX, sizeY);
        const interChunkPos = visualizer.simulationModel.getInterChunkPosition(bounds.startX, bounds.startY, 0, params);
        return `Chunk ${chunkIdx}: cells (${bounds.startX},${bounds.startY}) to (${bounds.endX - 1},${bounds.endY - 1}), Linear pos: ${interChunkPos}`;
    }
}




class $aaa98adcb0082ad2$export$45fa36fd3fe2417 {
    constructor(){
        this.cellLayoutCache = new (0, $dfa83648ad9dd0bd$export$182500e6725aad9a)((0, $17b1efe7f1246377$export$1630b5343357e8b5).LRU_CONFIG_CACHE_SIZE);
        this.linearLayoutCache = new (0, $dfa83648ad9dd0bd$export$182500e6725aad9a)((0, $17b1efe7f1246377$export$1630b5343357e8b5).LRU_CONFIG_CACHE_SIZE);
    }
    getCanvasCoordinates(e, canvas) {
        const rect = canvas.getBoundingClientRect();
        const scaleX = canvas.width / rect.width;
        const scaleY = canvas.height / rect.height;
        return {
            x: (e.clientX - rect.left) * scaleX,
            y: (e.clientY - rect.top) * scaleY
        };
    }
    getSpatialCellLayout(canvas, sizeX, sizeY) {
        const dpr = window.devicePixelRatio || 1;
        const cacheKey = JSON.stringify([
            canvas.width,
            canvas.height,
            sizeX,
            sizeY,
            dpr
        ]);
        if (this.cellLayoutCache.has(cacheKey)) return this.cellLayoutCache.get(cacheKey);
        const logicalWidth = canvas.width / dpr;
        const logicalHeight = canvas.height / dpr;
        const cellSize = Math.min(logicalWidth / sizeX, logicalHeight / sizeY) * 0.9;
        const offsetX = (logicalWidth - sizeX * cellSize) / 2;
        const offsetY = (logicalHeight - sizeY * cellSize) / 2;
        const layout = {
            cellSize: cellSize,
            offsetX: offsetX,
            offsetY: offsetY
        };
        this.cellLayoutCache.set(cacheKey, layout);
        return layout;
    }
    getSpatialCellCoordinates(canvasX, canvasY, canvas, params) {
        const [sizeX, sizeY] = params.size;
        // Convert canvas coordinates to logical coordinates
        const dpr = window.devicePixelRatio || 1;
        const logicalX = canvasX / dpr;
        const logicalY = canvasY / dpr;
        const { cellSize: cellSize, offsetX: offsetX, offsetY: offsetY } = this.getSpatialCellLayout(canvas, sizeX, sizeY);
        const cellX = Math.floor((logicalX - offsetX) / cellSize);
        const cellY = Math.floor((logicalY - offsetY) / cellSize);
        return {
            cellX: cellX,
            cellY: cellY,
            isValid: cellX >= 0 && cellX < sizeX && cellY >= 0 && cellY < sizeY,
            layout: {
                cellSize: cellSize,
                offsetX: offsetX,
                offsetY: offsetY
            }
        };
    }
    getLinearBarLayout(canvas, totalCells) {
        const dpr = window.devicePixelRatio || 1;
        const cacheKey = JSON.stringify([
            canvas.width,
            canvas.height,
            totalCells,
            dpr
        ]);
        if (this.linearLayoutCache.has(cacheKey)) return this.linearLayoutCache.get(cacheKey);
        const logicalWidth = canvas.width / dpr;
        const cellWidth = (logicalWidth - 40) / totalCells;
        const barHeight = 60;
        const offsetX = 20;
        const offsetY = 20;
        const layout = {
            cellWidth: cellWidth,
            barHeight: barHeight,
            offsetX: offsetX,
            offsetY: offsetY
        };
        this.linearLayoutCache.set(cacheKey, layout);
        return layout;
    }
    getLinearCellCoordinates(canvasX, canvasY, canvas, data) {
        const { cellWidth: cellWidth, barHeight: barHeight, offsetX: offsetX, offsetY: offsetY } = this.getLinearBarLayout(canvas, data.totalCells);
        const dpr = window.devicePixelRatio || 1;
        const logicalX = canvasX / dpr;
        const logicalY = canvasY / dpr;
        const isInBar = logicalY >= offsetY && logicalY <= offsetY + barHeight;
        const cellIndex = Math.floor((logicalX - offsetX) / cellWidth);
        const isValidIndex = cellIndex >= 0 && cellIndex < data.totalCells;
        return {
            cellIndex: cellIndex,
            isValid: isInBar && isValidIndex,
            layout: {
                cellWidth: cellWidth,
                barHeight: barHeight,
                offsetX: offsetX,
                offsetY: offsetY
            }
        };
    }
    getChunkCoordinatesFromCell(cellX, cellY, chunkX, chunkY) {
        return {
            x: Math.floor(cellX / chunkX),
            y: Math.floor(cellY / chunkY)
        };
    }
    clearCache() {
        this.cellLayoutCache.clear();
        this.linearLayoutCache.clear();
    }
}




class $da4ff8499e29e013$export$57c5077bf6f5e69d {
    constructor(canvas, context, visualizer, coordinateService){
        this.canvas = canvas;
        this.ctx = context;
        this.visualizer = visualizer;
        this.coordinateService = coordinateService;
    }
    getLogicalDimensions() {
        return {
            width: this.canvas.width / (window.devicePixelRatio || 1),
            height: this.canvas.height / (window.devicePixelRatio || 1)
        };
    }
    clearCanvas() {
        const { width: width, height: height } = this.getLogicalDimensions();
        this.ctx.clearRect(0, 0, width, height);
    }
    drawCellHighlight(x, y, cellSize, offsetX, offsetY, fillStyle = 'rgba(255, 255, 255, 0.4)', strokeStyle = '#fff', lineWidth = 3) {
        const cellX = offsetX + x * cellSize;
        const cellY = offsetY + y * cellSize;
        // For very small cells, use a different highlighting strategy
        if (cellSize < 3) {
            // For tiny cells, use a bright solid color that fills the entire cell
            this.ctx.fillStyle = '#ffff00'; // Bright yellow
            this.ctx.fillRect(cellX, cellY, Math.max(1, cellSize), Math.max(1, cellSize));
        } else if (cellSize < 8) {
            // For small cells, use a bright fill with minimal stroke
            this.ctx.fillStyle = 'rgba(255, 255, 0, 0.8)'; // Semi-transparent yellow
            this.ctx.fillRect(cellX, cellY, cellSize, cellSize);
            this.ctx.strokeStyle = '#ffff00';
            this.ctx.lineWidth = 1;
            this.ctx.strokeRect(cellX, cellY, cellSize, cellSize);
        } else {
            // For normal-sized cells, use the original approach with adaptive stroke width
            this.ctx.fillStyle = fillStyle;
            this.ctx.fillRect(cellX, cellY, cellSize - 1, cellSize - 1);
            this.ctx.strokeStyle = strokeStyle;
            this.ctx.lineWidth = Math.max(1, Math.min(lineWidth, cellSize / 3));
            this.ctx.strokeRect(cellX, cellY, cellSize - 1, cellSize - 1);
        }
    }
    drawRectHighlight(startX, startY, endX, endY, cellSize, offsetX, offsetY, fillStyle = 'rgba(255, 255, 255, 0.4)', strokeStyle = '#fff', lineWidth = 3) {
        const rectX = offsetX + startX * cellSize;
        const rectY = offsetY + startY * cellSize;
        const width = (endX - startX) * cellSize - 1;
        const height = (endY - startY) * cellSize - 1;
        // Adapt highlighting strategy based on cell size
        if (cellSize < 3) {
            // For tiny cells, use bright solid fill
            this.ctx.fillStyle = 'rgba(255, 255, 0, 0.6)'; // Semi-transparent yellow
            this.ctx.fillRect(rectX, rectY, Math.max(1, width), Math.max(1, height));
        } else if (cellSize < 8) {
            // For small cells, use bright fill with thin stroke
            if (fillStyle) {
                this.ctx.fillStyle = 'rgba(255, 255, 0, 0.3)'; // Light yellow
                this.ctx.fillRect(rectX, rectY, width, height);
            }
            if (strokeStyle) {
                this.ctx.strokeStyle = '#ffff00'; // Bright yellow
                this.ctx.lineWidth = Math.max(1, cellSize / 4);
                this.ctx.strokeRect(rectX, rectY, width, height);
            }
        } else {
            // For normal-sized cells, use adaptive stroke width
            if (fillStyle) {
                this.ctx.fillStyle = fillStyle;
                this.ctx.fillRect(rectX, rectY, width, height);
            }
            if (strokeStyle) {
                this.ctx.strokeStyle = strokeStyle;
                this.ctx.lineWidth = Math.max(1, Math.min(lineWidth, cellSize / 3));
                this.ctx.strokeRect(rectX, rectY, width, height);
            }
        }
    }
    drawQueryRegionOutline(query, sizeX, sizeY, cellSize, offsetX, offsetY) {
        this.ctx.strokeStyle = '#4a9eff';
        // Adaptive line width based on cell size
        this.ctx.lineWidth = Math.max(1, Math.min(3, cellSize / 2));
        const x1 = Math.max(0, query.x[0]);
        const y1 = Math.max(0, query.y[0]);
        const x2 = Math.min(sizeX - 1, query.x[1]);
        const y2 = Math.min(sizeY - 1, query.y[1]);
        this.ctx.strokeRect(offsetX + x1 * cellSize, offsetY + y1 * cellSize, (x2 - x1 + 1) * cellSize - 1, (y2 - y1 + 1) * cellSize - 1);
    }
    drawLinearBar(cellWidth, barHeight, offsetX, offsetY, totalCells, getColorForPosition) {
        if (cellWidth < 1) this.drawLinearGradientBar(offsetX, offsetY, totalCells * cellWidth, barHeight);
        else this.drawLinearCellBar(cellWidth, barHeight, offsetX, offsetY, totalCells, getColorForPosition);
    }
    drawLinearGradientBar(offsetX, offsetY, width, barHeight) {
        const gradient = this.ctx.createLinearGradient(offsetX, offsetY, offsetX + width, offsetY);
        gradient.addColorStop(0, '#00ff00');
        gradient.addColorStop(1, '#ff0000');
        this.ctx.fillStyle = gradient;
        this.ctx.fillRect(offsetX, offsetY, width, barHeight);
    }
    drawLinearCellBar(cellWidth, barHeight, offsetX, offsetY, totalCells, getColorForPosition) {
        for(let i = 0; i < totalCells; i++){
            const color = getColorForPosition(i, totalCells);
            this.ctx.fillStyle = color;
            const rect = this.calculateLinearRect(i, 1, cellWidth, offsetX, offsetY, barHeight);
            this.ctx.fillRect(rect.x, rect.y, rect.width, rect.height);
        }
    }
    // Helper method to calculate pixel-aligned rectangle dimensions
    calculateLinearRect(startPosition, cellCount, cellWidth, offsetX, offsetY, barHeight) {
        const startX = Math.round(offsetX + startPosition * cellWidth);
        const endX = Math.round(offsetX + (startPosition + cellCount) * cellWidth);
        const width = endX - startX;
        return {
            x: startX,
            y: offsetY,
            width: width,
            height: barHeight
        };
    }
    drawByteRanges(ranges, cellWidth, barHeight, offsetX, offsetY, label) {
        const { width: width } = this.getLogicalDimensions();
        const gap = 3;
        this.ctx.strokeStyle = '#4a9eff';
        this.ctx.lineWidth = 2;
        ranges.forEach(([start, end])=>{
            const x1 = offsetX + start * cellWidth;
            const x2 = offsetX + (end + 1) * cellWidth;
            this.ctx.beginPath();
            this.ctx.moveTo(x1, offsetY + barHeight + 5 + gap);
            this.ctx.lineTo(x2, offsetY + barHeight + 5 + gap);
            this.ctx.stroke();
            this.ctx.beginPath();
            this.ctx.moveTo(x1, offsetY + barHeight + gap);
            this.ctx.lineTo(x1, offsetY + barHeight + 10 + gap);
            this.ctx.moveTo(x2, offsetY + barHeight + gap);
            this.ctx.lineTo(x2, offsetY + barHeight + 10 + gap);
            this.ctx.stroke();
        });
        this.ctx.fillStyle = '#aaa';
        this.ctx.font = '11px monospace';
        this.ctx.textAlign = 'center';
        this.ctx.fillText(`${ranges.length} ${label}`, width / 2, offsetY + barHeight + 25 + gap);
    }
    highlightCoalescedRanges(positions, cellWidth, barHeight, offsetX, offsetY) {
        if (positions.length === 0) return;
        // Sort positions
        const sortedPositions = [
            ...positions
        ].sort((a, b)=>a - b);
        // Coalesce contiguous ranges
        const coalescedRanges = [];
        let currentRange = {
            min: sortedPositions[0],
            max: sortedPositions[0]
        };
        for(let i = 1; i < sortedPositions.length; i++){
            const pos = sortedPositions[i];
            // If this position is contiguous with the current range, extend it
            if (pos <= currentRange.max + 1) currentRange.max = pos;
            else {
                // Start a new range
                coalescedRanges.push(currentRange);
                currentRange = {
                    min: pos,
                    max: pos
                };
            }
        }
        // Don't forget the last range
        coalescedRanges.push(currentRange);
        // Draw outline around each coalesced range
        this.ctx.strokeStyle = '#4a9eff';
        this.ctx.lineWidth = 2;
        coalescedRanges.forEach((range)=>{
            const rangeWidth = (range.max - range.min + 1) * cellWidth;
            this.ctx.strokeRect(offsetX + range.min * cellWidth, offsetY, rangeWidth, barHeight);
        });
    }
    drawLinearChunkHighlight(chunkRange, cellWidth, barHeight, offsetX, offsetY, showOutline = false) {
        if (!chunkRange) return;
        this.ctx.fillStyle = 'rgba(255, 255, 255, 0.4)';
        const rect = this.calculateLinearRect(chunkRange.min, chunkRange.positions.length, cellWidth, offsetX, offsetY, barHeight);
        this.ctx.fillRect(rect.x, rect.y, rect.width, rect.height);
        if (showOutline) {
            this.ctx.strokeStyle = '#fff';
            this.ctx.lineWidth = 3;
            this.ctx.strokeRect(rect.x, rect.y, rect.width, rect.height);
        }
    }
    // Template method for rendering - to be implemented by subclasses
    render(_, __) {
        throw new Error('render() must be implemented by subclass');
    }
}
class $da4ff8499e29e013$export$68eecae0d0461f5d extends $da4ff8499e29e013$export$57c5077bf6f5e69d {
    render(params, data) {
        this.clearCanvas();
        const [sizeX, sizeY] = params.size;
        const { cellSize: cellSize, offsetX: offsetX, offsetY: offsetY } = this.coordinateService.getSpatialCellLayout(this.canvas, sizeX, sizeY);
        this.drawCellGrid(params, data, sizeX, sizeY, cellSize, offsetX, offsetY);
        this.drawSpatialHighlights(params, sizeX, sizeY, cellSize, offsetX, offsetY);
        this.drawQueryRegionOutline(params.query, sizeX, sizeY, cellSize, offsetX, offsetY);
    }
    drawCellGrid(params, data, sizeX, sizeY, cellSize, offsetX, offsetY) {
        if (cellSize > (0, $17b1efe7f1246377$export$1630b5343357e8b5).MIN_CELL_SIZE) this.drawDetailedCellGrid(params, data, sizeX, sizeY, cellSize, offsetX, offsetY);
        else {
            const gradient = this.ctx.createLinearGradient(offsetX, offsetY, offsetX + sizeX * cellSize, offsetY + sizeY * cellSize);
            gradient.addColorStop(0, '#00ff00');
            gradient.addColorStop(1, '#ff0000');
            this.ctx.fillStyle = gradient;
            this.ctx.fillRect(offsetX, offsetY, sizeX * cellSize, sizeY * cellSize);
        }
    }
    drawDetailedCellGrid(params, data, sizeX, sizeY, cellSize, offsetX, offsetY) {
        const { width: logicalWidth } = this.getLogicalDimensions();
        if (cellSize < (0, $17b1efe7f1246377$export$1630b5343357e8b5).VIEWPORT_CELL_SIZE && data.totalCells > 1000) {
            const startX = Math.max(0, Math.floor(-offsetX / cellSize));
            const endX = Math.min(sizeX, Math.ceil((logicalWidth - offsetX) / cellSize));
            const startY = Math.max(0, Math.floor(-offsetY / cellSize));
            const endY = Math.min(sizeY, Math.ceil((logicalWidth - offsetY) / cellSize));
            this.drawCellRange(params, data, startX, endX, startY, endY, cellSize, offsetX, offsetY);
        } else this.drawCellRange(params, data, 0, sizeX, 0, sizeY, cellSize, offsetX, offsetY);
    }
    drawCellRange(params, data, startX, endX, startY, endY, cellSize, offsetX, offsetY) {
        for(let y = startY; y < endY; y++)for(let x = startX; x < endX; x++){
            const globalPos = this.visualizer.simulationModel.getGlobalPosition(x, y, 0, params);
            const color = this.visualizer.getColorForLinearPosition(globalPos, data.totalCells - 1);
            this.ctx.fillStyle = color;
            this.ctx.fillRect(offsetX + x * cellSize, offsetY + y * cellSize, cellSize - 1, cellSize - 1);
        }
    }
    drawSpatialHighlights(params, sizeX, sizeY, cellSize, offsetX, offsetY) {
        const effectiveCell = this.visualizer.getEffectiveCell();
        const effectiveChunk = this.visualizer.getEffectiveChunk();
        if (cellSize > (0, $17b1efe7f1246377$export$1630b5343357e8b5).MIN_CELL_SIZE && effectiveCell) this.drawCellHighlight(effectiveCell.x, effectiveCell.y, cellSize, offsetX, offsetY);
        if (effectiveChunk && !effectiveCell) this.drawChunkCellHighlights(params, effectiveChunk, sizeX, sizeY, cellSize, offsetX, offsetY);
    }
    drawChunkCellHighlights(params, effectiveChunk, sizeX, sizeY, cellSize, offsetX, offsetY) {
        const [chunkSizeX, chunkSizeY] = params.chunk;
        const bounds = this.visualizer.simulationModel.getChunkBounds(effectiveChunk.x, effectiveChunk.y, chunkSizeX, chunkSizeY, sizeX, sizeY);
        this.drawRectHighlight(bounds.startX, bounds.startY, bounds.endX, bounds.endY, cellSize, offsetX, offsetY);
    }
}
class $da4ff8499e29e013$export$eb45a871bdfad28d extends $da4ff8499e29e013$export$57c5077bf6f5e69d {
    render(params, data) {
        this.clearCanvas();
        const [sizeX, sizeY, sizeZ] = params.size;
        const { cellSize: cellSize, offsetX: offsetX, offsetY: offsetY } = this.coordinateService.getSpatialCellLayout(this.canvas, sizeX, sizeY);
        const chunkColorMap = this.visualizer.simulationModel.getOrCreateChunkColorMap(params, sizeX, sizeY, sizeZ);
        this.drawChunkGrid(params, chunkColorMap, sizeX, sizeY, sizeZ, cellSize, offsetX, offsetY);
        this.drawChunkedViewHighlights(params, data, sizeX, sizeY, cellSize, offsetX, offsetY);
    }
    drawChunkGrid(params, chunkColorMap, sizeX, sizeY, sizeZ, cellSize, offsetX, offsetY) {
        const chunkGridInfo = this.calculateChunkGridInfo(params, sizeX, sizeY, sizeZ, cellSize, offsetX, offsetY);
        for(let chunkCY = chunkGridInfo.startChunkY; chunkCY < chunkGridInfo.endChunkY; chunkCY++)for(let chunkCX = chunkGridInfo.startChunkX; chunkCX < chunkGridInfo.endChunkX; chunkCX++)this.drawSingleChunk(chunkColorMap, chunkCX, chunkCY, chunkGridInfo.totalChunks, params, sizeX, sizeY, cellSize, offsetX, offsetY);
    }
    calculateChunkGridInfo(params, sizeX, sizeY, sizeZ, cellSize, offsetX, offsetY) {
        const [chunkX, chunkY] = params.chunk;
        const chunksX = Math.ceil(sizeX / chunkX);
        const chunksY = Math.ceil(sizeY / chunkY);
        const chunksZ = Math.ceil(Math.max(1, sizeZ) / Math.max(1, params.chunk[2]));
        const { width: logicalWidth, height: logicalHeight } = this.getLogicalDimensions();
        const viewport = this.getChunkViewport(chunksX, chunksY, cellSize, chunkX, chunkY, offsetX, offsetY, logicalWidth, logicalHeight);
        return {
            chunksX: chunksX,
            chunksY: chunksY,
            chunksZ: chunksZ,
            totalChunks: chunksX * chunksY * chunksZ,
            ...viewport
        };
    }
    getChunkViewport(chunksX, chunksY, cellSize, chunkX, chunkY, offsetX, offsetY, logicalWidth, logicalHeight) {
        if (cellSize < (0, $17b1efe7f1246377$export$1630b5343357e8b5).VIEWPORT_CELL_SIZE && chunksX * chunksY > 100) return {
            startChunkX: Math.max(0, Math.floor(-offsetX / (chunkX * cellSize))),
            endChunkX: Math.min(chunksX, Math.ceil((logicalWidth - offsetX) / (chunkX * cellSize))),
            startChunkY: Math.max(0, Math.floor(-offsetY / (chunkY * cellSize))),
            endChunkY: Math.min(chunksY, Math.ceil((logicalHeight - offsetY) / (chunkY * cellSize)))
        };
        return {
            startChunkX: 0,
            endChunkX: chunksX,
            startChunkY: 0,
            endChunkY: chunksY
        };
    }
    drawSingleChunk(chunkColorMap, chunkCX, chunkCY, totalChunks, params, sizeX, sizeY, cellSize, offsetX, offsetY) {
        const [chunkX, chunkY] = params.chunk;
        const chunkCZ = 0;
        const chunkKey = `${chunkCX},${chunkCY},${chunkCZ}`;
        const colorIndex = chunkColorMap.get(chunkKey);
        const color = this.visualizer.getColorForLinearPosition(colorIndex, totalChunks - 1);
        const bounds = this.visualizer.simulationModel.getChunkBounds(chunkCX, chunkCY, chunkX, chunkY, sizeX, sizeY);
        const chunkPixelWidth = (bounds.endX - bounds.startX) * cellSize;
        const chunkPixelHeight = (bounds.endY - bounds.startY) * cellSize;
        this.ctx.fillStyle = color;
        this.ctx.fillRect(offsetX + bounds.startX * cellSize, offsetY + bounds.startY * cellSize, chunkPixelWidth, chunkPixelHeight);
        this.ctx.strokeStyle = '#333';
        this.ctx.lineWidth = 1;
        this.ctx.strokeRect(offsetX + bounds.startX * cellSize, offsetY + bounds.startY * cellSize, chunkPixelWidth, chunkPixelHeight);
    }
    drawChunkedViewHighlights(params, data, sizeX, sizeY, cellSize, offsetX, offsetY) {
        const effectiveCell = this.visualizer.getEffectiveCell();
        const effectiveChunk = this.visualizer.getEffectiveChunk();
        const [chunkX, chunkY] = params.chunk;
        if (effectiveCell) {
            const chunkCoords = this.coordinateService.getChunkCoordinatesFromCell(effectiveCell.x, effectiveCell.y, chunkX, chunkY);
            const bounds = this.visualizer.simulationModel.getChunkBounds(chunkCoords.x, chunkCoords.y, chunkX, chunkY, sizeX, sizeY);
            this.drawRectHighlight(bounds.startX, bounds.startY, bounds.endX, bounds.endY, cellSize, offsetX, offsetY, 'rgba(255, 255, 255, 0.4)', '#fff');
        }
        this.drawTouchedChunksOutline(data, params, sizeX, sizeY, cellSize, offsetX, offsetY);
        if (effectiveChunk && !effectiveCell) {
            const bounds = this.visualizer.simulationModel.getChunkBounds(effectiveChunk.x, effectiveChunk.y, chunkX, chunkY, sizeX, sizeY);
            this.drawRectHighlight(bounds.startX, bounds.startY, bounds.endX, bounds.endY, cellSize, offsetX, offsetY);
        }
    }
    drawTouchedChunksOutline(data, params, sizeX, sizeY, cellSize, offsetX, offsetY) {
        if (data.touchedChunks.size === 0) return;
        const [chunkX, chunkY] = params.chunk;
        const chunksX = Math.ceil(sizeX / chunkX);
        let minChunkX = Infinity, minChunkY = Infinity;
        let maxChunkX = -Infinity, maxChunkY = -Infinity;
        data.touchedChunks.forEach((chunkIdx)=>{
            const chunkCY = Math.floor(chunkIdx / chunksX);
            const chunkCX = chunkIdx % chunksX;
            minChunkX = Math.min(minChunkX, chunkCX);
            minChunkY = Math.min(minChunkY, chunkCY);
            maxChunkX = Math.max(maxChunkX, chunkCX);
            maxChunkY = Math.max(maxChunkY, chunkCY);
        });
        const startX = minChunkX * chunkX;
        const startY = minChunkY * chunkY;
        const endX = Math.min((maxChunkX + 1) * chunkX, sizeX);
        const endY = Math.min((maxChunkY + 1) * chunkY, sizeY);
        this.ctx.strokeStyle = '#4a9eff';
        this.ctx.lineWidth = 3;
        this.ctx.strokeRect(offsetX + startX * cellSize, offsetY + startY * cellSize, (endX - startX) * cellSize - 1, (endY - startY) * cellSize - 1);
    }
}
class $da4ff8499e29e013$export$3ffcc588d7c2261a extends $da4ff8499e29e013$export$57c5077bf6f5e69d {
    render(params, data) {
        this.clearCanvas();
        const { cellWidth: cellWidth, barHeight: barHeight, offsetX: offsetX, offsetY: offsetY } = this.coordinateService.getLinearBarLayout(this.canvas, data.totalCells);
        this.drawLinearBar(cellWidth, barHeight, offsetX, offsetY, data.totalCells, (i, total)=>this.visualizer.getColorForLinearPosition(i, total));
        const requestedPositions = this.getRequestedCellPositions(data, params);
        this.highlightCoalescedRanges(requestedPositions, cellWidth, barHeight, offsetX, offsetY);
        this.drawLinearUnchunkedHighlights(params, cellWidth, barHeight, offsetX, offsetY);
        this.drawByteRanges(data.unchunkedRanges, cellWidth, barHeight, offsetX, offsetY, 'byte range(s)');
    }
    getRequestedCellPositions(data, params) {
        return [
            ...data.requestedCells
        ].map((key)=>{
            const [x, y, z] = key.split(',').map(Number);
            return this.visualizer.simulationModel.getGlobalPosition(x, y, z, params);
        });
    }
    drawLinearUnchunkedHighlights(params, cellWidth, barHeight, offsetX, offsetY) {
        const effectiveCell = this.visualizer.getEffectiveCell();
        const effectiveChunk = this.visualizer.getEffectiveChunk();
        if (effectiveChunk) {
            const chunkRange = this.visualizer.simulationModel.getChunkGlobalRange(effectiveChunk.x, effectiveChunk.y, params);
            this.drawLinearChunkHighlight(chunkRange, cellWidth, barHeight, offsetX, offsetY, !effectiveCell);
        }
        if (effectiveCell) {
            const pos = this.visualizer.simulationModel.getGlobalPosition(effectiveCell.x, effectiveCell.y, 0, params);
            this.ctx.strokeStyle = '#fff';
            this.ctx.lineWidth = 3;
            this.ctx.strokeRect(offsetX + pos * cellWidth, offsetY, cellWidth, barHeight);
        }
    }
}
class $da4ff8499e29e013$export$5f05a70b01f24992 extends $da4ff8499e29e013$export$57c5077bf6f5e69d {
    render(params, data) {
        this.clearCanvas();
        const { cellWidth: cellWidth, barHeight: barHeight, offsetX: offsetX, offsetY: offsetY } = this.coordinateService.getLinearBarLayout(this.canvas, data.totalCells);
        const [sizeX, sizeY, sizeZ] = params.size;
        const spatialChunkColorMap = this.visualizer.simulationModel.getOrCreateChunkColorMap(params, sizeX, sizeY, sizeZ);
        this.drawLinearChunks(params, data, spatialChunkColorMap, cellWidth, barHeight, offsetX, offsetY, sizeX, sizeY, sizeZ);
        this.highlightLinearChunks(params, data, cellWidth, barHeight, offsetX, offsetY);
        this.drawLinearChunkedHighlights(params, cellWidth, barHeight, offsetX, offsetY);
        this.drawByteRanges(data.chunkedRanges, cellWidth, barHeight, offsetX, offsetY, 'byte range(s) with chunking');
    }
    drawLinearChunks(params, _, spatialChunkColorMap, cellWidth, barHeight, offsetX, offsetY, sizeX, sizeY, sizeZ) {
        const [chunkSizeX, chunkSizeY] = params.chunk;
        const chunksX = Math.ceil(sizeX / chunkSizeX);
        const chunksY = Math.ceil(sizeY / chunkSizeY);
        const chunksZ3D = Math.ceil(Math.max(1, sizeZ) / Math.max(1, params.chunk[2]));
        const totalChunks3D = chunksX * chunksY * chunksZ3D;
        // Create a map of chunks to their global position ranges
        const chunkRanges = new Map();
        for(let cy = 0; cy < chunksY; cy++){
            for(let cx = 0; cx < chunksX; cx++)for(let cz = 0; cz < chunksZ3D; cz++){
                const chunkKey = `${cx},${cy},${cz}`;
                const colorIndex = spatialChunkColorMap.get(chunkKey);
                if (colorIndex !== undefined) {
                    const chunkRange = this.visualizer.simulationModel.getChunkGlobalRange(cx, cy, params);
                    if (chunkRange && chunkRange.positions.length > 0) chunkRanges.set(chunkKey, {
                        range: chunkRange,
                        color: this.visualizer.getColorForLinearPosition(colorIndex, totalChunks3D - 1)
                    });
                }
            }
        }
        // Draw each chunk as a single rectangle
        chunkRanges.forEach(({ range: range, color: color })=>{
            this.ctx.fillStyle = color;
            const rect = this.calculateLinearRect(range.min, range.positions.length, cellWidth, offsetX, offsetY, barHeight);
            this.ctx.fillRect(rect.x, rect.y, rect.width, rect.height);
        });
    }
    highlightLinearChunks(params, data, cellWidth, barHeight, offsetX, offsetY) {
        const [chunkSizeX, _] = params.chunk;
        const chunksX = Math.ceil(params.size[0] / chunkSizeX);
        const allPositions = [];
        // Get all positions from all touched chunks
        data.touchedChunks.forEach((chunkIdx)=>{
            const chunkCY = Math.floor(chunkIdx / chunksX);
            const chunkCX = chunkIdx % chunksX;
            const chunkRange = this.visualizer.simulationModel.getChunkGlobalRange(chunkCX, chunkCY, params);
            if (chunkRange && chunkRange.positions.length > 0) allPositions.push(...chunkRange.positions);
        });
        // Use the shared coalescing function
        this.highlightCoalescedRanges(allPositions, cellWidth, barHeight, offsetX, offsetY);
    }
    drawLinearChunkedHighlights(params, cellWidth, barHeight, offsetX, offsetY) {
        const effectiveChunk = this.visualizer.getEffectiveChunk();
        if (effectiveChunk) {
            const chunkRange = this.visualizer.simulationModel.getChunkGlobalRange(effectiveChunk.x, effectiveChunk.y, params);
            const showOutline = true;
            this.drawLinearChunkHighlight(chunkRange, cellWidth, barHeight, offsetX, offsetY, showOutline);
        }
    }
}



class $2dcb89ac52e7548c$export$d502697cd1eb82d4 {
    constructor(visualizer, tooltipManager){
        this.visualizer = visualizer;
        this.tooltipManager = tooltipManager;
    }
    // Template method for handling mouse moves
    handleMove(e, canvas, canvasKey) {
        const coords = this.visualizer.coordinateService.getCanvasCoordinates(e, canvas);
        const targetInfo = this.getTargetInfo(coords, canvas, canvasKey);
        if (targetInfo) {
            this.updateHoverState(targetInfo);
            this.showTooltip(e, targetInfo);
        } else this.clearHover();
    }
    // Template method for handling clicks
    handleClick(e, canvas, canvasKey) {
        const coords = this.visualizer.coordinateService.getCanvasCoordinates(e, canvas);
        const targetInfo = this.getTargetInfo(coords, canvas, canvasKey);
        this.handleSelectionLogic(e, targetInfo);
    }
    // Abstract methods to be implemented by subclasses
    getTargetInfo(_, __, ___) {
        throw new Error('getTargetInfo must be implemented by subclass');
    }
    updateHoverState(targetInfo) {
        if (targetInfo.cell) this.visualizer.selectionState.setHoveredCell(targetInfo.cell);
        if (targetInfo.chunk) this.visualizer.selectionState.setHoveredChunk(targetInfo.chunk);
    }
    showTooltip(e, targetInfo, sticky = false) {
        const params = this.visualizer.getParameters();
        if (targetInfo.cell && targetInfo.usesCellTooltip) this.tooltipManager.show(e, (0, $fca6475c668c1f3f$export$4b90d16989268d0).generateCellTooltip(targetInfo.cell, params, this.visualizer), sticky);
        else if (targetInfo.chunk) {
            const [sizeX, sizeY] = params.size;
            const [chunkX, chunkY] = params.chunk;
            this.tooltipManager.show(e, (0, $fca6475c668c1f3f$export$4b90d16989268d0).generateChunkTooltip(targetInfo.chunk, params, sizeX, sizeY, chunkX, chunkY, this.visualizer), sticky);
        }
    }
    clearHover() {
        this.visualizer.selectionState.clearHover();
        this.tooltipManager.hideIfNotSticky();
    }
    handleSelectionLogic(e, targetInfo) {
        const clickedCell = targetInfo?.cell;
        const clickedChunk = targetInfo?.chunk;
        if (clickedCell || clickedChunk) {
            // Check if clicking on already selected item to deselect
            if (this.visualizer.selectionState.isSelected(clickedCell, clickedChunk)) {
                this.visualizer.selectionState.clearSelection();
                this.tooltipManager.hide();
            } else {
                // Select new item
                this.visualizer.selectionState.setSelectedCell(clickedCell);
                this.visualizer.selectionState.setSelectedChunk(clickedChunk);
                this.showTooltip(e, targetInfo, true); // Make tooltip sticky
            }
        } else {
            // Clicked outside any item - clear selection
            this.visualizer.selectionState.clearSelection();
            this.tooltipManager.hide();
        }
    }
}
class $2dcb89ac52e7548c$export$aaa80641d584351c {
    constructor(visualizer, canvases, tooltipManager){
        this.visualizer = visualizer;
        this.canvases = canvases;
        this.tooltipManager = tooltipManager;
        this.mouseThrottle = false;
        // Initialize strategies
        const linearStrategy = new $2dcb89ac52e7548c$export$97a371dc2aa895fe(visualizer, tooltipManager);
        this.strategies = {
            spatialUnchunked: new $2dcb89ac52e7548c$export$d7aba106e61f7094(visualizer, tooltipManager),
            spatialChunked: new $2dcb89ac52e7548c$export$d9e8e21f8c65fa70(visualizer, tooltipManager),
            linearUnchunked: linearStrategy,
            linearChunked: linearStrategy
        };
    }
    handleMouseMove(e, canvasKey) {
        // Don't update anything if there's a selection - keep the selection locked
        if (this.visualizer.selectionState.hasSelection()) return;
        // Throttle mouse move updates for performance
        if (this.mouseThrottle) return;
        this.mouseThrottle = true;
        requestAnimationFrame(()=>{
            this.mouseThrottle = false;
        });
        const canvas = this.canvases[canvasKey];
        const strategy = this.strategies[canvasKey];
        if (strategy) {
            strategy.handleMove(e, canvas, canvasKey);
            this.visualizer.update();
        }
    }
    handleMouseLeave() {
        this.visualizer.selectionState.clearHover();
        this.tooltipManager.hideIfNotSticky();
        // Use requestAnimationFrame for smoother updates
        if (this.visualizer.updatePending) return;
        this.visualizer.updatePending = true;
        requestAnimationFrame(()=>{
            this.visualizer.updatePending = false;
            this.visualizer.update();
        });
    }
    handleMouseClick(e, canvasKey) {
        const canvas = this.canvases[canvasKey];
        const strategy = this.strategies[canvasKey];
        if (strategy) {
            strategy.handleClick(e, canvas, canvasKey);
            this.visualizer.update();
        }
    }
}
class $2dcb89ac52e7548c$export$d7aba106e61f7094 extends $2dcb89ac52e7548c$export$d502697cd1eb82d4 {
    getTargetInfo(coords, canvas, _) {
        const params = this.visualizer.getParameters();
        const { cellX: cellX, cellY: cellY, isValid: isValid } = this.visualizer.coordinateService.getSpatialCellCoordinates(coords.x, coords.y, canvas, params);
        if (!isValid) return null;
        const [chunkX, chunkY] = params.chunk;
        const cell = {
            x: cellX,
            y: cellY
        };
        const chunk = this.visualizer.coordinateService.getChunkCoordinatesFromCell(cellX, cellY, chunkX, chunkY);
        return {
            cell: cell,
            chunk: chunk,
            usesCellTooltip: true
        };
    }
}
class $2dcb89ac52e7548c$export$d9e8e21f8c65fa70 extends $2dcb89ac52e7548c$export$d502697cd1eb82d4 {
    getTargetInfo(coords, canvas, _) {
        const params = this.visualizer.getParameters();
        const { cellX: cellX, cellY: cellY, isValid: isValid } = this.visualizer.coordinateService.getSpatialCellCoordinates(coords.x, coords.y, canvas, params);
        if (!isValid) return null;
        const [chunkX, chunkY] = params.chunk;
        const chunk = this.visualizer.coordinateService.getChunkCoordinatesFromCell(cellX, cellY, chunkX, chunkY);
        return {
            chunk: chunk,
            usesCellTooltip: false
        };
    }
    updateHoverState(targetInfo) {
        this.visualizer.selectionState.setHoveredChunk(targetInfo.chunk);
        this.visualizer.selectionState.setHoveredCell(null);
    }
}
class $2dcb89ac52e7548c$export$97a371dc2aa895fe extends $2dcb89ac52e7548c$export$d502697cd1eb82d4 {
    getTargetInfo(coords, canvas, canvasKey) {
        const data = this.visualizer.currentData;
        if (!data) return null;
        const { cellIndex: cellIndex, isValid: isValid } = this.visualizer.coordinateService.getLinearCellCoordinates(coords.x, coords.y, canvas, data);
        if (!isValid) return null;
        const params = this.visualizer.getParameters();
        const [sizeX, sizeY] = params.size;
        const [chunkX, chunkY] = params.chunk;
        const foundCell = this.visualizer.simulationModel.getCellFromLinearIndex(cellIndex, params, sizeX, sizeY, chunkX, chunkY);
        if (!foundCell) return null;
        const cell = {
            x: foundCell.x,
            y: foundCell.y
        };
        const chunk = {
            x: foundCell.chunkX,
            y: foundCell.chunkY
        };
        const usesCellTooltip = canvasKey === 'linearUnchunked';
        return {
            cell: cell,
            chunk: chunk,
            usesCellTooltip: usesCellTooltip
        };
    }
    updateHoverState(targetInfo) {
        const usesCell = targetInfo.usesCellTooltip;
        this.visualizer.selectionState.setHoveredCell(usesCell ? targetInfo.cell : null);
        this.visualizer.selectionState.setHoveredChunk(targetInfo.chunk);
    }
    handleSelectionLogic(e, targetInfo) {
        if (!targetInfo) {
            // Clicked outside any item - clear selection
            this.visualizer.selectionState.clearSelection();
            this.tooltipManager.hide();
            return;
        }
        const usesCell = targetInfo.usesCellTooltip;
        const clickedCell = usesCell ? targetInfo.cell : null;
        const clickedChunk = targetInfo.chunk;
        if (clickedCell || clickedChunk) {
            // Check if clicking on already selected item to deselect
            if (this.visualizer.selectionState.isSelected(clickedCell, clickedChunk)) {
                this.visualizer.selectionState.clearSelection();
                this.tooltipManager.hide();
            } else {
                // Select new item - only set cell for linearUnchunked, always set chunk
                this.visualizer.selectionState.setSelectedCell(clickedCell);
                this.visualizer.selectionState.setSelectedChunk(clickedChunk);
                this.showTooltip(e, targetInfo, true); // Make tooltip sticky
            }
        } else {
            // Clicked outside any item - clear selection
            this.visualizer.selectionState.clearSelection();
            this.tooltipManager.hide();
        }
    }
}



class $014ef9082e1842d5$export$4ee6706e93ed0e72 {
    constructor(visualizer){
        this.visualizer = visualizer;
        this.canvases = {};
        this.contexts = {};
        this.renderers = {};
        this.lastCanvasSize = new Map();
    }
    initializeCanvases() {
        this.canvases = {
            spatialUnchunked: document.getElementById('spatial-unchunked'),
            spatialChunked: document.getElementById('spatial-chunked'),
            linearUnchunked: document.getElementById('linear-unchunked'),
            linearChunked: document.getElementById('linear-chunked')
        };
        this.tooltipManager = new (0, $fca6475c668c1f3f$export$3cf29e47efa41626)(document.getElementById('tooltip'));
        this.interactionManager = new (0, $2dcb89ac52e7548c$export$aaa80641d584351c)(this.visualizer, this.canvases, this.tooltipManager);
        this.contexts = {};
        this.renderers = {};
        for (const [key, canvas] of Object.entries(this.canvases)){
            this.contexts[key] = canvas.getContext('2d');
            // Create specialized renderers
            switch(key){
                case 'spatialUnchunked':
                    this.renderers[key] = new (0, $da4ff8499e29e013$export$68eecae0d0461f5d)(canvas, this.contexts[key], this.visualizer, this.visualizer.coordinateService);
                    break;
                case 'spatialChunked':
                    this.renderers[key] = new (0, $da4ff8499e29e013$export$eb45a871bdfad28d)(canvas, this.contexts[key], this.visualizer, this.visualizer.coordinateService);
                    break;
                case 'linearUnchunked':
                    this.renderers[key] = new (0, $da4ff8499e29e013$export$3ffcc588d7c2261a)(canvas, this.contexts[key], this.visualizer, this.visualizer.coordinateService);
                    break;
                case 'linearChunked':
                    this.renderers[key] = new (0, $da4ff8499e29e013$export$5f05a70b01f24992)(canvas, this.contexts[key], this.visualizer, this.visualizer.coordinateService);
                    break;
            }
            // Add mouse interaction for spatial and linear views
            if (key.startsWith('spatial') || key.startsWith('linear')) {
                canvas.addEventListener('mousemove', (e)=>this.interactionManager.handleMouseMove(e, key));
                canvas.addEventListener('mouseleave', ()=>this.interactionManager.handleMouseLeave());
                canvas.addEventListener('click', (e)=>this.interactionManager.handleMouseClick(e, key));
            }
        }
        this.setupResizeHandling();
        this.setupGlobalClickHandler();
        // Force initial resize after DOM is ready
        setTimeout(()=>{
            this.resizeCanvases();
            this.visualizer.update();
        }, 0);
        this.resizeCanvases();
    }
    setupResizeHandling() {
        let resizeRAF = null;
        const handleResize = ()=>{
            if (resizeRAF) return;
             // Prevent multiple concurrent updates
            resizeRAF = requestAnimationFrame(()=>{
                const needsUpdate = this.resizeCanvases();
                if (needsUpdate) this.visualizer.update();
                resizeRAF = null;
            });
        };
        // Only use window resize - simpler and more reliable
        window.addEventListener('resize', handleResize);
    }
    setupGlobalClickHandler() {
        // Clear selection when clicking outside visualizations
        document.addEventListener('click', (e)=>{
            // Check if click was inside any canvas
            let clickedCanvas = false;
            for (const canvas of Object.values(this.canvases)){
                const rect = canvas.getBoundingClientRect();
                if (e.clientX >= rect.left && e.clientX <= rect.right && e.clientY >= rect.top && e.clientY <= rect.bottom) {
                    clickedCanvas = true;
                    break;
                }
            }
            // If clicked outside all canvases, clear selection
            if (!clickedCanvas && this.visualizer.selectionState.hasSelection()) {
                this.visualizer.selectionState.clearSelection();
                this.tooltipManager.hide();
                this.visualizer.update();
            }
        });
    }
    setCanvasSize(key, width, height) {
        const canvas = this.canvases[key];
        const ctx = this.contexts[key];
        const dpr = window.devicePixelRatio || 1;
        canvas.width = width * dpr;
        canvas.height = height * dpr;
        canvas.style.width = width + 'px';
        canvas.style.height = height + 'px';
        // Reset transform before scaling to prevent accumulation
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.scale(dpr, dpr);
    }
    resizeCanvases() {
        let needsUpdate = false;
        // Spatial canvases - square aspect
        [
            'spatialUnchunked',
            'spatialChunked'
        ].forEach((key)=>{
            const canvas = this.canvases[key];
            const canvasContainer = canvas.parentElement; // .canvas-container
            const vizPanel = canvasContainer.parentElement; // .viz-panel
            const containerRect = vizPanel.getBoundingClientRect();
            // Account for viz-panel padding (15px) and canvas-container padding (10px)
            const vizPanelPadding = 15;
            const canvasContainerPadding = 20; // 10px on each side
            const totalPadding = vizPanelPadding * 2 + canvasContainerPadding;
            const availableWidth = containerRect.width - totalPadding;
            const size = Math.min(availableWidth, (0, $17b1efe7f1246377$export$1630b5343357e8b5).MAX_CANVAS_SIZE);
            const lastSize = this.lastCanvasSize.get(key);
            if (size > 0 && (!lastSize || lastSize.width !== size || lastSize.height !== size)) {
                this.setCanvasSize(key, size, size);
                this.lastCanvasSize.set(key, {
                    width: size,
                    height: size
                });
                needsUpdate = true;
            }
        });
        // Linear canvases - full width
        [
            'linearUnchunked',
            'linearChunked'
        ].forEach((key)=>{
            const canvas = this.canvases[key];
            const canvasContainer = canvas.parentElement; // .canvas-container
            const linearViz = canvasContainer.parentElement; // .linear-viz
            const containerRect = linearViz.getBoundingClientRect();
            // Account for linear-viz padding (15px) and canvas-container padding (10px)
            const linearVizPadding = 15;
            const canvasContainerPadding = 20; // 10px on each side
            const totalPadding = linearVizPadding * 2 + canvasContainerPadding;
            const width = containerRect.width - totalPadding;
            const height = 120;
            const lastSize = this.lastCanvasSize.get(key);
            if (width > 0 && (!lastSize || lastSize.width !== width || lastSize.height !== height)) {
                this.setCanvasSize(key, width, height);
                this.lastCanvasSize.set(key, {
                    width: width,
                    height: height
                });
                needsUpdate = true;
            }
        });
        return needsUpdate;
    }
    renderAll(params, data) {
        // Draw all views using specialized renderers
        this.renderers.spatialUnchunked.render(params, data);
        this.renderers.spatialChunked.render(params, data);
        this.renderers.linearUnchunked.render(params, data);
        this.renderers.linearChunked.render(params, data);
    }
}




class $ba19924693538bd9$export$84c857aa8abbae0e {
    constructor(){
        this.simulationModel = new (0, $b1019273282b83c2$export$3dcc190b101a2a42)();
        this.coordinateService = new (0, $aaa98adcb0082ad2$export$45fa36fd3fe2417)();
        this.settingsManager = new (0, $ea8ee40d2fbcc01b$export$3016a1f47b675883)();
        this.selectionState = new (0, $fca6475c668c1f3f$export$2255d92a85eab347)();
        this.colorCache = new (0, $dfa83648ad9dd0bd$export$182500e6725aad9a)((0, $17b1efe7f1246377$export$1630b5343357e8b5).LRU_DETAIL_CACHE_SIZE);
        this.canvasManager = new (0, $014ef9082e1842d5$export$4ee6706e93ed0e72)(this);
        this.initializeControls();
        this.canvasManager.initializeCanvases();
        this.updateUI();
        this.update();
    }
    setState(newState) {
        this.settingsManager.setState(newState);
    }
    updateUI() {
        this.settingsManager.renderUI();
        this.settingsManager.updateDOMConstraints();
        this.updateResetButton();
        this.updatePresetDisplay();
        this.update();
    }
    clearCaches() {
        this.colorCache.clear();
        if (this.coordinateService) this.coordinateService.clearCache();
    // simulationModel caches are not cleared here, they have their own lifecycle
    }
    populatePresetOptions() {
        const presetsSelect = document.getElementById('presets');
        Object.keys((0, $17b1efe7f1246377$export$25fa20faab981607)).forEach((presetKey)=>{
            const option = document.createElement('option');
            option.value = presetKey;
            option.textContent = this.settingsManager.getPresetDisplayName(presetKey, true);
            presetsSelect.appendChild(option);
        });
    }
    initializeControls() {
        this.populatePresetOptions();
        const controls = [
            'cellAlgorithm',
            'chunkAlgorithm',
            'sizeX',
            'sizeY',
            'sizeZ',
            'chunkX',
            'chunkY',
            'chunkZ',
            'queryX1',
            'queryX2',
            'queryY1',
            'queryY2',
            'queryZ1',
            'queryZ2'
        ];
        controls.forEach((id)=>{
            const element = document.getElementById(id);
            element.addEventListener('change', (e)=>{
                let value = e.target.type === 'number' ? parseInt(e.target.value) : e.target.value;
                if (e.target.type === 'number') {
                    if (isNaN(value)) {
                        console.warn(`Invalid input value: ${e.target.value}, resetting to 1`);
                        value = 1;
                    } else {
                        if (id.startsWith('size') || id.startsWith('chunk')) value = Math.max(1, value);
                        else value = Math.max(0, value);
                        if (id.startsWith('size')) value = Math.min(value, 256);
                        if (id === 'sizeZ') value = Math.min(value, 16);
                    }
                }
                this.setState({
                    [id]: value
                });
                this.updateUI();
                this.settingsManager.saveSettings();
            });
        });
        document.getElementById('presets').addEventListener('change', (e)=>{
            this.settingsManager.loadPreset(e.target.value);
            this.updateUI();
            this.settingsManager.saveSettings();
        });
        document.getElementById('resetButton').addEventListener('click', ()=>{
            this.settingsManager.resetCurrentPreset();
            this.updateUI();
            this.settingsManager.saveSettings();
        });
        this.updateConstraints();
        this.updateResetButton();
    }
    updateResetButton() {
        const resetButton = document.getElementById('resetButton');
        const shouldShow = this.settingsManager.shouldShowResetButton();
        resetButton.disabled = !shouldShow;
        resetButton.style.opacity = shouldShow ? '1' : '0.5';
    }
    updatePresetDisplay() {
        const presetsSelect = document.getElementById('presets');
        presetsSelect.querySelectorAll('option').forEach((option)=>{
            option.textContent = this.settingsManager.getPresetDisplayName(option.value, true);
        });
    }
    updateConstraints() {
        const updates = this.settingsManager.validateAndClampState();
        this.settingsManager.updateDOMConstraints();
        if (Object.keys(updates).length > 0) {
            this.setState(updates);
            this.settingsManager.renderUI();
        }
    }
    getParameters() {
        const state = this.settingsManager.state;
        return {
            cellAlgorithm: state.cellAlgorithm,
            chunkAlgorithm: state.chunkAlgorithm,
            size: [
                state.sizeX,
                state.sizeY,
                state.sizeZ
            ],
            chunk: [
                state.chunkX,
                state.chunkY,
                state.chunkZ
            ],
            query: {
                x: [
                    state.queryX1,
                    state.queryX2
                ],
                y: [
                    state.queryY1,
                    state.queryY2
                ],
                z: [
                    state.queryZ1,
                    state.queryZ2
                ]
            }
        };
    }
    getColorForLinearPosition(position, maxPosition) {
        const key = `${position}-${maxPosition}`;
        const cachedColor = this.colorCache.get(key);
        if (cachedColor) return cachedColor;
        const hue = 120 - position / maxPosition * 120;
        const color = `hsl(${hue}, 70%, 50%)`;
        this.colorCache.set(key, color);
        return color;
    }
    getEffectiveCell() {
        return this.selectionState.getEffectiveCell();
    }
    getEffectiveChunk() {
        return this.selectionState.getEffectiveChunk();
    }
    update() {
        const params = this.getParameters();
        document.getElementById('zRange').style.display = params.size[2] > 1 ? 'flex' : 'none';
        const data = this.simulationModel.calculateData(params);
        this.currentData = data;
        this.canvasManager.renderAll(params, data);
        this.updateMetrics(data);
    }
    updateMetrics(data) {
        const amplification = data.actualCells.size / Math.max(1, data.requestedCells.size);
        const coalescingFactor = data.touchedChunks.size / Math.max(1, data.chunkedRanges.length);
        const amplificationScore = 1 / Math.max(1, amplification);
        const rangeScore = 1 / Math.max(1, data.chunkedRanges.length);
        const storageAlignment = 0.9 * amplificationScore + 0.1 * rangeScore;
        document.getElementById('requested-cells').textContent = data.requestedCells.size;
        document.getElementById('actual-cells').textContent = data.actualCells.size;
        document.getElementById('amplification').innerHTML = amplification.toFixed(2) + '<span class="metric-suffix">x</span>';
        document.getElementById('chunks-touched').textContent = data.touchedChunks.size;
        document.getElementById('byte-ranges').textContent = data.chunkedRanges.length;
        document.getElementById('efficiency').innerHTML = (100 / amplification).toFixed(1) + '<span class="metric-suffix">%</span>';
        document.getElementById('coalescing-factor').innerHTML = coalescingFactor.toFixed(1) + '<span class="metric-suffix">x</span>';
        document.getElementById('storage-alignment').textContent = storageAlignment.toFixed(2);
    }
}


// Auto-generated build information
const $04b8cf952a63a727$export$d99074480c2c53b7 = {
    "commit": "76f3a013",
    "buildTime": "2025-09-07T17:35:24.448Z"
};


// Initialize on load
document.addEventListener('DOMContentLoaded', ()=>{
    new (0, $ba19924693538bd9$export$84c857aa8abbae0e)();
    // Update footer with build information
    const commitHashElement = document.getElementById('commit-hash');
    if (commitHashElement) commitHashElement.textContent = (0, $04b8cf952a63a727$export$d99074480c2c53b7).commit;
});


//# sourceMappingURL=vischunk.0a69e0da.js.map
